import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import WhatsAppButton from "./components/WhatsAppButton";

import Links from "./pages/Links";
import Contact from "./pages/Contact";
import About from "./pages/About";
import DegreeAcademics from "./pages/DegreeAcademics";
import PgAcademics from "./pages/PgAcademics";
import CoursesOffered from "./pages/CoursesOffered";

import Admin from "./pages/Admin";

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/academics" element={<DegreeAcademics />} />
        <Route path="/courses-offered" element={<CoursesOffered />} />
        <Route path="/academics/degree" element={<DegreeAcademics />} />
        <Route path="/academics/pg" element={<PgAcademics />} />
        <Route path="/links" element={<Links />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />

        <Route path="/admin" element={<Admin />} />
      </Routes>

      <Footer />

      <WhatsAppButton />
    </Router>
  );
}

export default App;